import React from 'react';
import ReactDOM from 'react-dom';
import VideoPlayer from '../../VideoPlayer/VideoPlayer';
import ImageDisplay from '../../ImageDisplay/ImageDisplay';
import { processVideoUrl, MediaType } from '../../../utils/media';
/**
 * 미디어 모달 컴포넌트
 */ var MediaModal = function(param) {
    var isOpen = param.isOpen, allMedia = param.allMedia, activeIndex = param.activeIndex, onClose = param.onClose, onPrev = param.onPrev, onNext = param.onNext, onIndexChange = param.onIndexChange, getMediaType = param.getMediaType, isMediaShortForm = param.isMediaShortForm, isMediaNormalVideo = param.isMediaNormalVideo, createPortalRoot = param.createPortalRoot;
    if (!isOpen) return null;
    var currentMediaUrl = allMedia[activeIndex];
    var currentMediaType = getMediaType(currentMediaUrl);
    var isCurrentShortForm = isMediaShortForm(currentMediaUrl);
    var isCurrentNormalVideo = isMediaNormalVideo(currentMediaUrl);
    return /*#__PURE__*/ ReactDOM.createPortal(/*#__PURE__*/ React.createElement("div", {
        className: "fixed inset-0 flex items-center justify-center bg-black bg-opacity-95 backdrop-blur-sm",
        onClick: onClose,
        style: {
            position: 'fixed',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            zIndex: 99999,
            pointerEvents: 'auto',
            isolation: 'isolate',
            width: '100vw',
            height: '100vh'
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: "relative w-full h-full flex flex-col items-center justify-center px-4 py-10"
    }, /*#__PURE__*/ React.createElement("button", {
        className: "absolute top-5 right-5 text-white p-2 rounded-full bg-white bg-opacity-10 hover:bg-opacity-20 transition-all duration-300 backdrop-blur-md",
        onClick: function(e) {
            e.stopPropagation();
            onClose(e);
        },
        "aria-label": "닫기"
    }, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: "h-6 w-6",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, /*#__PURE__*/ React.createElement("line", {
        x1: "18",
        y1: "6",
        x2: "6",
        y2: "18"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "6",
        y1: "6",
        x2: "18",
        y2: "18"
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "relative w-full h-full max-w-6xl max-h-full flex items-center justify-center overflow-hidden"
    }, renderMediaContent(currentMediaUrl, currentMediaType, isCurrentShortForm, isCurrentNormalVideo), allMedia.length > 1 && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("button", {
        className: "absolute left-4 p-3 rounded-full bg-white bg-opacity-10 hover:bg-opacity-20 transition-all duration-300 text-white backdrop-blur-md",
        onClick: function(e) {
            e.stopPropagation();
            onPrev(e);
        },
        "aria-label": "이전 미디어"
    }, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: "h-7 w-7",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor"
    }, /*#__PURE__*/ React.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M15 19l-7-7 7-7"
    }))), /*#__PURE__*/ React.createElement("button", {
        className: "absolute right-4 p-3 rounded-full bg-white bg-opacity-10 hover:bg-opacity-20 transition-all duration-300 text-white backdrop-blur-md",
        onClick: function(e) {
            e.stopPropagation();
            onNext(e);
        },
        "aria-label": "다음 미디어"
    }, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: "h-7 w-7",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor"
    }, /*#__PURE__*/ React.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M9 5l7 7-7 7"
    }))))), /*#__PURE__*/ React.createElement("div", {
        className: "absolute bottom-6 left-0 right-0 flex justify-center"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex space-x-2 px-4 py-2 bg-black bg-opacity-60 backdrop-blur-sm rounded-full"
    }, allMedia.length > 1 && allMedia.map(function(_, index) {
        return /*#__PURE__*/ React.createElement("button", {
            key: "indicator-".concat(index),
            className: "w-2.5 h-2.5 rounded-full transition-all ".concat(index === activeIndex ? 'bg-white scale-110' : 'bg-gray-500 hover:bg-gray-400'),
            onClick: function(e) {
                e.stopPropagation();
                onIndexChange(index);
            },
            "aria-label": "미디어 ".concat(index + 1, "로 이동")
        });
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "absolute top-5 left-5 bg-white bg-opacity-10 backdrop-blur-sm text-white px-3 py-1 rounded-full text-sm font-medium"
    }, activeIndex + 1, " / ", allMedia.length))), createPortalRoot());
};
/**
 * 미디어 타입에 따라 적절한 컨텐츠를 렌더링
 */ function renderMediaContent(mediaUrl, mediaType, isShortForm, isNormalVideo) {
    if (mediaType === MediaType.VIDEO) {
        return /*#__PURE__*/ React.createElement("div", {
            className: "relative w-full max-h-full ".concat(isShortForm ? 'max-w-md' : 'max-w-5xl', " rounded-xl overflow-hidden shadow-2xl"),
            onClick: function(e) {
                return e.stopPropagation();
            }
        }, /*#__PURE__*/ React.createElement("div", {
            className: isShortForm ? "aspect-[9/16] bg-black" : "aspect-[16/9]"
        }, /*#__PURE__*/ React.createElement(VideoPlayer, {
            src: processVideoUrl(mediaUrl),
            width: "100%",
            height: "100%",
            autoPlay: true,
            controls: true,
            muted: false,
            loop: true,
            className: "w-full h-full ".concat(isNormalVideo ? "object-contain" : "object-contain")
        })), isShortForm && /*#__PURE__*/ React.createElement("div", {
            className: "absolute top-3 right-3 bg-white bg-opacity-90 backdrop-blur-sm text-gray-800 text-xs font-medium px-2.5 py-1 rounded-full shadow-md"
        }, "숏폼"));
    } else if (mediaType === MediaType.IMAGE) {
        return /*#__PURE__*/ React.createElement("div", {
            className: "relative max-w-5xl max-h-full rounded-xl overflow-hidden shadow-2xl",
            onClick: function(e) {
                return e.stopPropagation();
            }
        }, /*#__PURE__*/ React.createElement(ImageDisplay, {
            src: processVideoUrl(mediaUrl),
            alt: "갤러리 이미지",
            className: "max-h-[80vh] object-contain"
        }));
    } else {
        // 모달 내 링크 또는 알 수 없는 타입 처리
        return /*#__PURE__*/ React.createElement("div", {
            className: "flex items-center justify-center bg-gray-800 text-white p-6 rounded-xl max-w-md backdrop-blur-md shadow-xl",
            onClick: function(e) {
                return e.stopPropagation();
            }
        }, /*#__PURE__*/ React.createElement("span", null, "이 미디어는 갤러리에서 미리 볼 수 없습니다."), mediaType === MediaType.LINK && /*#__PURE__*/ React.createElement("a", {
            href: mediaUrl,
            target: "_blank",
            rel: "noopener noreferrer",
            className: "ml-3 px-3 py-1 bg-white bg-opacity-20 rounded-full hover:bg-opacity-30 transition-all duration-300",
            onClick: function(e) {
                return e.stopPropagation();
            }
        }, "링크 열기"));
    }
}
export default MediaModal;
